import { VideoType } from "../../const/fixed/Types";

export const VideoPlayerData = {
  Holding: {
    enabled: true,
    type: VideoType.youtube,
    id: "Holding",
    link: "/assets/content/sample.pdf",
    name: "ComingSoon",
    videoCode: "VoeUTFTXrOk",
    description: "",
  },
  Video1: {
    enabled: false,
    type: VideoType.vimeo,
    id: "Video1",
    link: "https://vimeo.com/334905384",
    name: "Neymar",
    videoCode: "781333669",
    description: `All content is copy right of R1RCM, strictly non-shareable on any medium. We would request all participants to support the same.
        In case you need any Get Connected related content reach out to R1 India's communication team.`,
  },
};

export const LobbyStall1VideoPlayer = {
  Holding: {
    enabled: true,
    type: VideoType.youtube,
    id: "Holding",
    link: "https://youtu.be/VoeUTFTXrOk",
    name: "ComingSoon",
    videoCode: "VoeUTFTXrOk",
    description: "",
  },
  Video2: {
    enabled: true,
    type: VideoType.youtube,
    id: "Holding",
    link: "https://www.youtube.com/rCoPr8UwRMc",
    name: "ComingSoon",
    videoCode: "rCoPr8UwRMc",
    description: "",
  },
};

export const LobbyStall1PdfPlayer = {
  Holding: {
    enabled: true,
    id: "Holding",
    link: "/web/viewer.html?file=%2Fassets%2Fcontent%2FAgenda.pdf",
    name: "pdf-1",
    description: "",
  },
};

export const LobbyStall1BusinessCardPlayer = {
  card1: {
    enabled: true,
    id: "card1",
    link: "/web/viewer.html?file=%2Fassets%2Fcontent%2FAgenda.pdf",
    name: "pdf-1",
    description: "",
  },
};
